import { mapSimpleArticlesInterface } from 'connectors/articleInterface/ArticleInterface';
import { mapListedBrandsApiData } from 'connectors/brands/Brands';
import { mapListedCategoryConnectionApiData } from 'connectors/categories/Categories';
import { mapListedProductConnectionPreviewType } from 'connectors/products/Products';
import { ProductFilterApi, ProductOrderingModeEnumApi, SearchQueryApi, useSearchQueryApi } from 'graphql/generated';
import { isServer } from 'helpers/isServer';
import { useQueryError } from 'hooks/graphQl/UseQueryError';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { useEffect, useState } from 'react';
import { EMPTY_SEARCH_RESULT, SearchType } from 'types/search';

export const useSearch = (
    searchQuery: string | undefined,
    searchProductsSort: ProductOrderingModeEnumApi | null,
    optionsFilter: ProductFilterApi | null,
): { fetching: boolean; searchResults: SearchType | undefined } => {
    const [result] = useSearchQueryApi({
        variables: {
            search: searchQuery ?? '',
            orderingMode: searchProductsSort,
            filter: optionsFilter,
        },
        pause: !searchQuery,
    });

    const { currencyCode } = useDomainConfig();
    const [mappedResult, setMappedResult] = useState<SearchType | undefined>(
        searchQuery ? mapSearchResult(result.data) : EMPTY_SEARCH_RESULT,
    );

    useQueryError(result.error);
    useEffect(() => {
        if (!result.stale) {
            setMappedResult(mapSearchResult(result.data));
        }
    }, [currencyCode, result.data, result.stale]);

    if (isServer() && result.data !== undefined) {
        return { fetching: result.fetching, searchResults: mapSearchResult(result.data) };
    }

    return { fetching: result.fetching, searchResults: mappedResult };
};

const mapSearchResult = (apiData: SearchQueryApi | undefined): SearchType | undefined => {
    if (apiData === undefined) {
        return EMPTY_SEARCH_RESULT;
    }

    return {
        articlesSearch: mapSimpleArticlesInterface(apiData.articlesSearch),
        brandSearch: mapListedBrandsApiData(apiData.brandSearch),
        categoriesSearch: mapListedCategoryConnectionApiData(apiData.categoriesSearch),
        productsSearch: mapListedProductConnectionPreviewType(apiData.productsSearch),
    };
};
